import AppContext from "../../AppContext";
import "./profilPage.css";
import { Alert, Button, MenuItem, Select, Tab, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  getPayment,
  fetchActiveSeason,
  getPaymentUrl,
  markPaymentAsSuccessful,
  pullUserData,
  saveUserData,
  createReceipt,
  updateReceipt,
  sendVerificationEmail,
  reloadAuthData,
  pullReceiptsByUser,
  getMyBadge,
} from "../../db/firebaseMethods";
import { Link, useNavigate } from "react-router-dom";
import {
  YEARS,
  CITIES,
  EDUCATIONS,
  OCCUPATIONS,
  WHERE_DID_YOU_HEAR,
} from "../../common/constants";
import EditIcon from "@mui/icons-material/Edit";
import LockIcon from "@mui/icons-material/Lock";
import LoadingBlock from "../../components/organisms/loadingBlock/loadingBlock";
import Grid from "@mui/material/Grid";
import moment from "moment/moment";
import "moment/locale/tr";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  degrees,
  drawTextField,
  PDFDocument,
  rgb,
  StandardFonts,
  TextAlignment,
} from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { downloadModifiedPdf, loadTtfFont } from "../../common/functions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EventIcon from "@mui/icons-material/Event";
import LocationOnIcon from "@mui/icons-material/LocationOn";


export default function ProfilePage() {
  const { setCentralState, user, activeSeason } = React.useContext(AppContext);
  if (!user) {
    return null;
  }

  return (
    <div className="profilePageContainer">
      {GeneratePersonalInfoBox(user)}
      <TcNoBox user={user} />
      <MyBadgeBox user={user} />
      {/* {GenerateSurveyBox(user, activeSeason)} */}
      {GenerateActiveProductBox(user)}
      {GenerateDocumentsBox(user, activeSeason)}
    </div>
  );
}

// T.C. Kimlik No doğrulama algoritması (11 hane, resmi sağlama kuralları)
const isValidTcNo = (tc) => {
  if (!/^[1-9]\d{10}$/.test(tc)) return false;
  const d = tc.split("").map(Number);
  const odd = d[0] + d[2] + d[4] + d[6] + d[8];
  const even = d[1] + d[3] + d[5] + d[7];
  if (((odd * 7 - even) % 10 + 10) % 10 !== d[9]) return false;
  return d.slice(0, 10).reduce((a, b) => a + b, 0) % 10 === d[10];
};

// Admin panelinde "TC iste" işaretlenen bir atölyeyi satın alan kullanıcıdan TC Kimlik No ister.
const TcNoBox = ({ user }) => {
  const { refreshUserData, activeSeason } = React.useContext(AppContext);
  const [tc, setTc] = useState(user.tc_no || "");
  const [editing, setEditing] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const tcProducts = Object.keys(activeSeason?.products ?? {}).filter(
    (pid) =>
      activeSeason.products[pid]?.requires_tc === true ||
      activeSeason.products[pid]?.requires_wifi === true
  );
  const requiredWorkshops = tcProducts.filter((pid) =>
    (user.activeSeasonReceipts ?? []).some(
      (r) => r.is_paid && r.receipt_products?.[pid] === true
    )
  );

  if (requiredWorkshops.length === 0) return null;

  // Wifi gereken atölyeler (internet erişimi için TC gerekir) ile sadece TC istenenler ayrı anlatılır.
  const titleOf = (pid) => activeSeason.products[pid]?.title ?? pid;
  const wifiWorkshops = requiredWorkshops.filter((pid) => activeSeason.products[pid]?.requires_wifi === true);
  const tcOnlyWorkshops = requiredWorkshops.filter((pid) => activeSeason.products[pid]?.requires_wifi !== true);

  const hasSaved = !!user.tc_no;
  const showForm = !hasSaved || editing;
  const valid = isValidTcNo(tc);

  const save = async () => {
    if (!valid) {
      alert("Geçerli bir T.C. Kimlik No giriniz.");
      return;
    }
    setLoading(true);
    try {
      await saveUserData(user.uid, { tc_no: tc });
      await refreshUserData();
      setEditing(false);
    } catch (e) {
      console.error(e);
      alert("TC Kimlik No kaydedilemedi, lütfen tekrar deneyin.");
    }
    setLoading(false);
  };

  return (
    <div className="personelInfoBox">
      {isLoading && <LoadingBlock />}
      <h3 className="pageHeader">T.C. KİMLİK NO</h3>
      {wifiWorkshops.length > 0 && (
        <div className="labelRow">
          <span>
            Satın aldığınız şu atölye(ler) wifi (internet bağlantısı) gerektirmektedir. Kongre alanında
            wifi erişiminin tanımlanabilmesi için T.C. Kimlik Numaranızı girmeniz gerekmektedir:{" "}
            <b>{wifiWorkshops.map(titleOf).join(", ")}</b>
          </span>
        </div>
      )}
      {tcOnlyWorkshops.length > 0 && (
        <div className="labelRow">
          <span>
            Satın aldığınız şu atölye(ler) için T.C. Kimlik Numaranızı girmeniz gerekmektedir:{" "}
            <b>{tcOnlyWorkshops.map(titleOf).join(", ")}</b>
          </span>
        </div>
      )}
      {showForm ? (
        <div style={{ marginTop: 16, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "flex-start" }}>
          <TextField
            label="T.C. Kimlik No"
            value={tc}
            onChange={(e) => setTc(e.target.value.replace(/\D/g, "").slice(0, 11))}
            size="small"
            style={{ width: 250 }}
            autoComplete="off"
            inputProps={{ inputMode: "numeric", maxLength: 11 }}
            error={tc.length > 0 && !valid && tc.length === 11}
            helperText={
              tc.length === 11 && !valid ? "Geçerli bir T.C. Kimlik No giriniz" : "11 haneli kimlik numaranız"
            }
          />
          <Button variant="outlined" color="secondary" onClick={save} disabled={!valid}>
            Kaydet
          </Button>
          {hasSaved && (
            <Button
              variant="outlined"
              onClick={() => {
                setTc(user.tc_no);
                setEditing(false);
              }}
            >
              Vazgeç
            </Button>
          )}
        </div>
      ) : (
        <div className="labelRow" style={{ marginTop: 12 }}>
          <div className="label">T.C. Kimlik No</div> <span>{user.tc_no}</span>
          <Button
            className="editButton"
            variant="contained"
            onClick={() => setEditing(true)}
          >
            <EditIcon style={{ fontSize: 18, marginRight: 3 }} /> Düzenle
          </Button>
        </div>
      )}
    </div>
  );
};

// Kongre bileti alan kullanıcının giriş bileti (QR'lı). Girişte telefondan gösterilir.
const MyBadgeBox = ({ user }) => {
  const [badge, setBadge] = useState(null); // { code, image } | "none" | "error"
  const hasPaid = (user.activeSeasonReceipts ?? []).some((r) => r.is_paid);

  useEffect(() => {
    if (!hasPaid) return;
    let cancelled = false;
    getMyBadge()
      .then((r) => !cancelled && setBadge(r.eligible ? r : "none"))
      .catch(() => !cancelled && setBadge("error"));
    return () => { cancelled = true; };
    // Satın alım değişince (ör. yeni atölye) bilet güncellensin diye makbuz sayısına bağlı.
  }, [hasPaid, user.activeSeasonReceipts?.length]);

  if (!hasPaid || badge === "none") return null;

  return (
    <div className="personelInfoBox">
      <h3 className="pageHeader">GİRİŞ BİLETİM</h3>
      <div className="labelRow">
        <span>
          Kongre girişinde bu biletteki QR kodu görevlilere okutun. Bileti telefonunuza indirebilirsiniz.
        </span>
      </div>
      {badge === "error" && (
        <Alert severity="error" sx={{ mt: 2 }}>Bilet yüklenemedi, lütfen sayfayı yenileyin.</Alert>
      )}
      {!badge && <div style={{ marginTop: 16 }}>Bilet hazırlanıyor...</div>}
      {badge?.image && (
        <div style={{ marginTop: 16 }}>
          <img src={badge.image} alt="Giriş Bileti" style={{ width: "100%", maxWidth: 360, borderRadius: 12 }} />
          <div style={{ marginTop: 12 }}>
            <Button
              variant="contained"
              color="secondary"
              component="a"
              href={badge.image}
              download={`${badge.code}.png`}
              sx={{ textTransform: "none", fontWeight: 600, borderRadius: "12px" }}
            >
              Bileti İndir
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

const GenerateDocumentsBox = (user, activeSeason) => {
  return (
    <div className="personelInfoBox">
      <h3 className="pageHeader">BELGELERİM</h3>
      <div className="labelRow">
        <div>
          <span>
            Etkinlik sonrasında katılım belgesi düzenlenecektir. Belgelerinizi kongre bittikten sonra bu alandan indirebilirsiniz.
          </span>
        </div>
      </div>
    </div>
  );
};

const renderKongrePdfDownloadButton = (user, activeSeason) => {
  const handleKongrePdfDownload = async () => {
    if (!user.name) {
      alert("Lütfen önce profil bilgilerinizi güncelleyiniz.");
      return;
    }
    
    const pdfUrlKongre = require("../../files/pdfs/kongre.pdf");
    const customFontBytes = await loadTtfFont(
      require("../../files/fonts/Decima Bold 2.ttf")
    );

    const xhr = new XMLHttpRequest();
    xhr.open("GET", pdfUrlKongre, true);
    xhr.responseType = "arraybuffer";
    xhr.onload = async function () {
      if (xhr.status === 200) {
        const arrayBuffer = xhr.response;
        const pdfDoc = await PDFDocument.load(arrayBuffer);
        pdfDoc.registerFontkit(fontkit);

        const customFont = await pdfDoc.embedFont(customFontBytes);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        const { width, height } = firstPage.getSize();
        const textWidth = customFont.widthOfTextAtSize(user?.name, 40);

        firstPage.drawText(user?.name.toLocaleUpperCase("TR"), {
          x: (width - textWidth) / 2 - 5,
          y: height / 2 - 40,
          size: 40,
          font: customFont,
          color: rgb(0.255, 0.247, 0.525),
        });
        firstPage.drawText(user?.uid, {
          x: 10,
          y: 10,
          size: 8,
          font: customFont,
          color: rgb(0.255, 0.247, 0.525),
        });
        const pdfBytes = await pdfDoc.save();
        downloadModifiedPdf(pdfBytes, "KongreKatilimBelgesi");
      } else {
        alert("Belge indirilirken bir sorun oldu.");
      }
    };
    xhr.send();
  };

  return (
    user.activeSeasonReceipts.length > 0 && (
      <Button
        sx={{
          minWidth: 180,
          height: 40,
          fontSize: '16px',
          fontWeight: 600,
          borderRadius: '12px',
          textTransform: 'none',
          boxShadow: '0 4px 12px rgba(10, 24, 39, 0.3)',
          '&:hover': {
            boxShadow: '0 6px 16px rgba(14, 28, 43, 0.4)',
            transform: 'translateY(-2px)',
          },
          transition: 'all 0.3s ease',
        }}
        onClick={handleKongrePdfDownload}
        variant="contained"
        color="secondary"
      >
         Kongre Katılım Belgesi
      </Button>
    )
  );
};

const renderAtolyePdfDownloadButton = (user, activeSeason) => {
  const handleAtolyePdfDownload = async () => {
    if (!user.name) {
      alert("Lütfen önce profil bilgilerinizi güncelleyiniz.");
      return;
    }
    
    const receipts = user.activeSeasonReceipts;
    const pdfUrlAtolye = require("../../files/pdfs/atolye.pdf");
    const customFontBytes = await loadTtfFont(
      require("../../files/fonts/Decima Bold 2.ttf")
    );

    let products = [];
    if (receipts.length > 0) {
      const workshopProductIds = new Set();
      receipts.forEach((r) => {
        if (!r?.receipt_products) return;
        Object.keys(r.receipt_products).forEach((receiptItem) => {
          if (activeSeason?.products[receiptItem]?.product_type === 2) {
            workshopProductIds.add(receiptItem);
          }
        });
      });

      products = Array.from(workshopProductIds).map((id) => ({
        title: activeSeason?.products[id]?.title,
        moderator: activeSeason?.products[id]?.moderator,
        start_at: new Date(activeSeason?.products[id]?.start_at)?.toLocaleDateString("tr-TR", { timeZone: "Europe/Istanbul" }),
      }));
    }

    products.forEach((p, index) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", pdfUrlAtolye, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = async function () {
        if (xhr.status === 200) {
          const arrayBuffer = xhr.response;
          const pdfDoc = await PDFDocument.load(arrayBuffer);
          pdfDoc.registerFontkit(fontkit);

          const customFont = await pdfDoc.embedFont(customFontBytes);
          const pages = pdfDoc.getPages();
          const firstPage = pages[0];
          const { width, height } = firstPage.getSize();

          const textWidth = customFont.widthOfTextAtSize(user?.name, 40);

          firstPage.drawText(user?.name.toLocaleUpperCase("TR"), {
            x: (width - textWidth) / 2 - 5,
            y: height / 2 - 35,
            size: 40,
            font: customFont,
            color: rgb(0.255, 0.247, 0.525), 
          });

          firstPage.drawText(p?.title, {
            x: 170,
            y: height / 2 - 126,
            size: 9,
            font: customFont,
            color: rgb(0.255, 0.247, 0.525),
          });
          firstPage.drawText(p?.moderator, {
            x: 170,
            y: height / 2 - 142,
            size: 10,
            font: customFont,
            color: rgb(0.255, 0.247, 0.525),
          });
          firstPage.drawText(user?.uid, {
            x: 10,
            y: 10,
            size: 8,
            font: customFont,
          });
          const pdfBytes = await pdfDoc.save();
          downloadModifiedPdf(pdfBytes, `AtolyeKatilimBelgesi${index + 1}`);
        } else {
          alert("Belge indirilirken bir sorun oldu.");
        }
      };
      xhr.send();
    });
  };

  // Atölye belgesi olup olmadığını kontrol et
  const hasWorkshopCertificate = (() => {
    const receipts = user.activeSeasonReceipts || [];
    if (receipts.length === 0) return false;
    for (const r of receipts) {
      const items = Object.keys(r?.receipt_products || {});
      for (const item of items) {
        if (activeSeason?.products[item]?.product_type === 2) return true;
      }
    }
    return false;
  })();

  return (
    hasWorkshopCertificate && (
      <Button
        sx={{
          minWidth: 180,
          height: 40,
          fontSize: '16px',
          fontWeight: 600,
          borderRadius: '12px',
          textTransform: 'none',
          boxShadow: '0 4px 12px rgba(156, 39, 176, 0.3)',
          '&:hover': {
            boxShadow: '0 6px 16px rgba(156, 39, 176, 0.4)',
            transform: 'translateY(-2px)',
          },
          transition: 'all 0.3s ease',
        }}
        onClick={handleAtolyePdfDownload}
        variant="contained"
        color="secondary"
      >
         Atölye Katılım Belgeleri
      </Button>
    )
  );
};

const renderParticipationPdfDownloadButton = (user, activeSeason) => {
  const handlePdfDownloadForParticipation = async () => {
    const receipts = user.activeSeasonReceipts; //await pullReceiptsByUser(user?.uid, activeSeason?.id);

    if (!user.name) {
      alert("Lütfen önce profil bilgilerinizi güncelleyiniz.");
      return;
    }
    const pdfUrlKongre = require("../../files/pdfs/kongre.pdf");
    const pdfUrlAtolye = require("../../files/pdfs/atolye.pdf");

    const customFontBytes = await loadTtfFont(
      // "https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf"
      require("../../files/fonts/Decima Bold 2.ttf")
    );

    const xhr = new XMLHttpRequest();
    xhr.open("GET", pdfUrlKongre, true);
    xhr.responseType = "arraybuffer";
    xhr.onload = async function () {
      if (xhr.status === 200) {
        const arrayBuffer = xhr.response;
        const pdfDoc = await PDFDocument.load(arrayBuffer);
        pdfDoc.registerFontkit(fontkit);

        const customFont = await pdfDoc.embedFont(customFontBytes);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        const { width, height } = firstPage.getSize();
        const textWidth = customFont.widthOfTextAtSize(user?.name, 40);

        firstPage.drawText(user?.name.toLocaleUpperCase("TR"), {
          x: (width - textWidth) / 2 - 5,
          y: height / 2 - 40,
          size: 40,
          font: customFont,
        });
        firstPage.drawText(user?.uid, {
          x: 10,
          y: 10,
          size: 8,
          font: customFont,
        });
        const pdfBytes = await pdfDoc.save();
        downloadModifiedPdf(pdfBytes, "KongreKatilimBelgesi");

        //TODO: add the products info to serparate pdf files
      } else {
        alert("Belge indirilirken bir sorun oldu.");
      }
    };
    xhr.send();

    let products = [];

    if (receipts.length > 0 && receipts?.[0]?.receipt_products) {
      Object.keys(receipts?.[0]?.receipt_products).forEach((receiptItem) => {
        if (![3, 1].includes(activeSeason?.products[receiptItem]?.product_type))
          products.push({
            title: activeSeason?.products[receiptItem]?.title,
            moderator: activeSeason?.products[receiptItem]?.moderator,
            start_at: new Date(
              activeSeason?.products[receiptItem]?.start_at
            )?.toLocaleDateString("tr-TR", { timeZone: "Europe/Istanbul" }),
          });
      });
    }

    products.forEach((p, index) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", pdfUrlAtolye, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = async function () {
        if (xhr.status === 200) {
          const arrayBuffer = xhr.response;
          const pdfDoc = await PDFDocument.load(arrayBuffer);
          pdfDoc.registerFontkit(fontkit);

          const customFont = await pdfDoc.embedFont(customFontBytes);
          const pages = pdfDoc.getPages();
          const firstPage = pages[0];
          const { width, height } = firstPage.getSize();

          const textWidth = customFont.widthOfTextAtSize(user?.name, 40);

          firstPage.drawText(user?.name.toLocaleUpperCase("TR"), {
            x: (width - textWidth) / 2 - 5,
            y: height / 2 - 35,
            size: 40,
            font: customFont,
            color: rgb(0.255, 0.247, 0.525), 
          });

          firstPage.drawText(p?.title, {
            x: 170,
            y: height / 2 - 126,
            size: 9,
            font: customFont,
            color: rgb(0.255, 0.247, 0.525), // #413f86
          });
          firstPage.drawText(p?.moderator, {
            x: 170,
            y: height / 2 - 142,
            size: 10,
            font: customFont,
            color: rgb(0.255, 0.247, 0.525), // #413f86
          });
          firstPage.drawText(user?.uid, {
            x: 10,
            y: 10,
            size: 8,
            font: customFont,
          });
          const pdfBytes = await pdfDoc.save();
          downloadModifiedPdf(pdfBytes, `AtolyeKatilimBelgesi${index + 1}`);
        } else {
          alert("Belge indirilirken bir sorun oldu.");
        }
      };
      xhr.send();
    });

    return;
  };

  return (
    user.activeSeasonReceipts.length > 0 && (
      <Button
        sx={{
          width: 300,
          mt: 2,

          // marginLeft: "50%",
          // transform: "translateX(-50%)",
        }}
        onClick={handlePdfDownloadForParticipation}
        variant="contained"
        color="error"
      >
        Katılım BELGELERİNİZİ İNDİRİN
      </Button>
    )
  );
};

// Katılımcıların araç plakasını bildirmesi için son tarih (Türkiye saati)
const PLATE_DEADLINE = new Date("2026-11-01T23:59:00+03:00");

const PlateNotice = ({ user }) => {
  const hasPaid = (user.activeSeasonReceipts ?? []).some((r) => r.is_paid);
  if (!hasPaid || user.car_plate || new Date() > PLATE_DEADLINE) return null;
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      Plaka bilginizi bildirmemiz için lütfen <b>1 Kasım 23.59</b>'a kadar aşağıdaki "Plaka" alanını doldurunuz.
    </Alert>
  );
};

const GeneratePersonalInfoBox = (user) => {
  const { refreshUserData, setCentralState, activeSeason } =
    React.useContext(AppContext);
  const [editModeEnabled, setEditMode] = useState(false);
  const [newName, setName] = useState(user.name || "");
  const [newPhone, setPhone] = useState(user.phone || "");
  const [carPlate, setCarPlate] = useState(user.car_plate || "");
  const [gender, setGender] = useState(user.gender || "");
  const [city, setCity] = useState(user.city || "");
  const [education, setEducation] = useState(user.education || "");
  const [occupation, setOccupation] = useState(user.occupation || "");
  const [newBirthYear, setBirthYear] = useState(user.birth_year || 0);
  const [previousAttendance, setPreviousAttendance] = useState(
    user.previous_attendance || ""
  );
  const [whereDidYouHear, setWhereDidYouHear] = useState(
    user.where_did_you_hear || ""
  );

  const [isLoading, setLoading] = useState(false);

  const isAllCompulsaryFieldsFilled =
    user &&
    user.name &&
    user.birth_year &&
    user.gender &&
    user.city &&
    user.education &&
    user.previous_attendance &&
    user.occupation &&
    user.where_did_you_hear;

  const saveProfileData = async (id, data) => {
    let missingFields = [];
    [
      newName,
      newPhone,
      gender,
      city,
      education,
      occupation,
      newBirthYear,
      previousAttendance,
      whereDidYouHear,
    ].forEach((f) => {
      if (!f) missingFields.push(f);
    });

    if (missingFields.length > 0) {
      alert("Lütfen tüm bilgileri doldurunuz!");
    } else {
      setLoading(true);
      await saveUserData(id, data);
      await refreshUserData();
      setLoading(false);
      setEditMode(false);
    }
  };

  if (editModeEnabled || !isAllCompulsaryFieldsFilled) {
    return (
      <div className="personelInfoBox">
        {isLoading && <LoadingBlock />}
        <h3 className="pageHeader">KİŞİSEL BİLGİLERİNİZ</h3>
        <PlateNotice user={user} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              id="newName"
              label="Adı-Soyadı"
              name="newName"
              value={newName}
              onChange={(e) => {
                const value = e.target.value;
                const filteredValue = value.replace(
                  /[^a-zA-ZğüşıöçĞÜŞİÖÇ\s]/g,
                  ""
                );
                const pascalCaseValue = filteredValue
                  .split(" ")
                  .map((word) => {
                    return (
                      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                    );
                  })
                  .join(" ");
                setName(pascalCaseValue);
              }}
              autoComplete={"disabled"}
              style={{ width: 250 }}
              size="small"
              error={newName?.length < 3}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              id="newPhone"
              label="Telefon"
              name="newPhone"
              value={newPhone}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
              autoComplete="disabled"
              style={{ width: 250 }}
              size="small"
              error={newPhone?.length < 11}
              helperText={
                newPhone?.length < 11
                  ? "Geçerli bir telefon numarası giriniz"
                  : ""
              }
              inputProps={{ maxLength: 11 }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              id="carPlate"
              label="Plaka"
              name="carPlate"
              value={carPlate}
              onChange={(e) => {
                const value = e.target.value.toUpperCase();
                setCarPlate(value);
              }}
              autoComplete="disabled"
              style={{ width: 250 }}
              size="small"
              helperText="1 Kasım 23.59'a kadar doldurunuz"
              inputProps={{ maxLength: 20 }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              id="yearChooser"
              value={newBirthYear}
              onChange={(e) => setBirthYear(e.target.value)}
              label="Doğum Yılı"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
              error={!newBirthYear}
            >
              {YEARS.map((y) => (
                <MenuItem key={y + "yil_menu"} value={y}>
                  {y}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              id="genderChooser"
              error={!gender}
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              label="Cinsiyet"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
            >
              <MenuItem value="Kadın">Kadın</MenuItem>
              <MenuItem value="Erkek">Erkek</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              value={city}
              onChange={(e) => setCity(e.target.value)}
              label="Şehir"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
              error={!city}
            >
              {CITIES.map((c) => (
                <MenuItem key={c + "city_menu"} value={c}>
                  {c}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              error={!education}
              select
              value={education}
              onChange={(e) => setEducation(e.target.value)}
              label="Eğitim Durumu"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
            >
              {EDUCATIONS.map((c) => (
                <MenuItem key={c + "education_menu"} value={c}>
                  {c}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              value={occupation}
              onChange={(e) => setOccupation(e.target.value)}
              label="Meslek"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
              error={!occupation}
            >
              {OCCUPATIONS.map((c) => (
                <MenuItem key={c + "occupation_menu"} value={c}>
                  {c}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              value={previousAttendance}
              onChange={(e) => setPreviousAttendance(e.target.value)}
              label="Önceki Etkinliklere Katıldınız Mı?"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
              error={!previousAttendance}
            >
              {["EVET", "HAYIR"].map((c) => (
                <MenuItem key={c + "_previous_attendance_menu"} value={c}>
                  {c}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              value={whereDidYouHear}
              onChange={(e) => setWhereDidYouHear(e.target.value)}
              label="Nereden Haberdar Oldunuz?"
              style={{ width: 250 }}
              className="yearSelector"
              size="small"
              error={!whereDidYouHear}
            >
              {WHERE_DID_YOU_HEAR.map((c) => (
                <MenuItem key={c + "where_did_you_hear_menu"} value={c}>
                  {c}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <div className="profileButtonsContainer">
              <div className="profileButtons">
                <Button
                  variant="outlined"
                  onClick={() => {
                    setEditMode(false);
                  }}
                >
                  Vazgeç
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    saveProfileData(user.uid, {
                      name: newName.trim(),
                      birth_year: newBirthYear,
                      email: user.email,
                      phone: newPhone,
                      car_plate: carPlate.trim(),
                      gender,
                      city,
                      education,
                      occupation,
                      previous_attendance: previousAttendance,
                      where_did_you_hear: whereDidYouHear,
                    });
                  }}
                >
                  Kaydet
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  } else {
    return (
      <>
        <div className="personelInfoBox">
          <h3 className="pageHeader">KİŞİSEL BİLGİLERİNİZ</h3>
          <PlateNotice user={user} />
          <div className="labelRow">
            <div className="label">E-Posta</div> <span>{user.email}</span>
          </div>
          <div className="labelRow">
            <div className="label">Adı-Soyadı </div> <span>{user.name}</span>{" "}
          </div>
          <div className="labelRow">
            <div className="label">Telefon </div> <span>{user.phone}</span>{" "}
          </div>
          <div className="labelRow">
            <div className="label">Plaka </div> <span>{user.car_plate}</span>{" "}
          </div>
          <div className="labelRow">
            <div className="label">Yaşadığı Şehir </div>{" "}
            <span>{user.city}</span>
          </div>
          <div className="labelRow">
            <div className="label">Doğum Yılı </div>{" "}
            <span>{user.birth_year}</span>
          </div>
          <div className="labelRow">
            <div className="label">Eğitim Durumu</div>{" "}
            <span>{user.education}</span>
          </div>
          <div className="labelRow">
            <div className="label">Meslek</div> <span>{user.occupation}</span>
          </div>

          <Button
            className="editButton"
            variant="contained"
            onClick={() => {
              setEditMode(true);
            }}
          >
            <EditIcon style={{ fontSize: 18, marginRight: 3 }} /> Düzenle
          </Button>
        </div>
    {/*     <div className="personelInfoBox">
          <h3 className="pageHeader">BİLGİLENDİRME</h3>
          <div className="labelRow">
            <div>
              {" "}
              <span>
                ODTÜ'lü katılımcılara kongre ana ücreti üzerinden %40 indirim
                uygulanacaktır. İndirimden yararlanmak için metu uzantılı
                e-posta adresinizle kongre@tzv.org.tr adresine mail
                atabilirsiniz. Kontenjan 200 kişi ile sınırlıdır.
              </span>
            </div>
          </div>
        </div> */}
      </>
    );
  }
};

const GenerateSurveyBox = (user, activeSeason) => {
  const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLScXa1CypUcDBVWCI5LNaqVVtacQ6rVg0AW0rz3O8JHgPhkMNA/viewform?usp=preview";
  if (!user || !activeSeason || !GOOGLE_FORM_URL) return null;

  return (
    <div className="personelInfoBox">
      <h3 className="pageHeader">DEĞERLENDİRME ANKETİ</h3>
      <div style={{ textAlign: "center", marginBottom: 12, color: "#333" }}>
        <span>
          Kongre deneyiminizi kısaca değerlendirmenizi rica ederiz. 
        </span>
      </div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 12,  }}>
        <Button
          variant="contained"
          color="secondary"
          component="a"
          sx={{ textTransform: "capitalize" }}
          href={GOOGLE_FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Değerlendirme Anketini Doldur
        </Button>
      </div>
    </div>
  );
};

const GenerateActiveProductBox = (user) => {
  const navigate = useNavigate();

  const { refreshUserData, setCentralState, activeSeason } =
    React.useContext(AppContext);
  const [isPurchseTriggered, setIsPurchaseTriggered] = useState(false);
  const [paidProducts, setPaidProducts] = useState({}); // {1: true, 2: true}
  const [selectedProducts, setSelectedProducts] = useState({}); // {1: true, 2: true}
  const [workshopDays, setWorkshopDays] = useState({}); // {"25-01-2023": [{workshop1}, {workshop2}], "26-01-2023": [{workshop3}, {workshop4}]} şeklinde bir objedir.
  const [mainProduct, setMainProduct] = useState(null);
  const activeSeasonProductsObject = activeSeason?.products || {}; // {1: {p1}, 2: {p2}, 3: {p3}}

  useEffect(() => {
    const paid = {};
    user.activeSeasonReceipts?.forEach((r) => {
      Object.keys(r.receipt_products || {}).forEach((pId) => {
        paid[pId] = {
          paid_by_group: r.paid_by_group || false,
          paid_by_name: r.paid_by_name || null,
          paid_by_email: r.paid_by_email || null,
        };
      });
    });
    setPaidProducts(paid);
  }, [user]);

  useEffect(() => {
    // activeSeason değiştiğinde önce sıfırla
    setMainProduct(null);
    const productIds = Object.keys(activeSeasonProductsObject);
    let workshopDaysTemp = {};
    productIds.forEach((pId) => {
      const p = activeSeasonProductsObject[pId];
      p.id = pId;

      if (p?.product_type === 1) {
        setMainProduct(p);
      } else if (p.start_at && p?.product_type !== 1) {
        const start_day_str = moment(p.start_at)
          .format("DD MMMM YYYY dddd")
          .toString();
        if (!workshopDaysTemp[start_day_str])
          workshopDaysTemp[start_day_str] = [];

        workshopDaysTemp[start_day_str].push(p);
        workshopDaysTemp[start_day_str]
          .sort((w1, w2) => (w1?.title || "").localeCompare(w2?.title || ""))
          .sort((w1, w2) => w1.start_at - w2.start_at);
      }
    });

    setWorkshopDays(workshopDaysTemp);
  }, [activeSeason]);

  useEffect(() => {
    // ürün seçildiğinde çakışan ürünlerin seçimini kaldırır.

    const paidOrSelectedProducts = { ...selectedProducts, ...paidProducts };
    const productIds = Object.keys(paidOrSelectedProducts);
    if (Object.keys(workshopDays).length === 0) return;

    let workshopDaysTemp = { ...workshopDays };

    Object.keys(workshopDaysTemp).forEach((day) => {
      const workshops = workshopDaysTemp[day];

      workshops.forEach((w) => {
        let isOverlapping = false;
        productIds.forEach((pId) => {
          const checkedProduct = activeSeasonProductsObject[pId];
          if (
            checkedProduct?.id === w?.id ||
            w?.product_type === 3 ||
            checkedProduct?.product_type === 3
          )
            return;

          const maxStart = new Date(
            Math.max(w?.start_at, checkedProduct?.start_at)
          );
          const minEnd = new Date(Math.min(w?.end_at, checkedProduct?.end_at));

          if (maxStart < minEnd) isOverlapping = true;
        });

        w.isOverlapping = isOverlapping;
      });
    });
    setWorkshopDays(workshopDaysTemp);
  }, [paidProducts, selectedProducts]);

  const isMainProductStocksZero = (mainProduct?.stock ?? 0) < 1;
  const isMainProductPaid = !!paidProducts[mainProduct?.id];

  const paymentOkIndicator = (paidInfo) => (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
      <Chip variant="outlined" icon={<CheckCircleIcon />} label="ÖDENDİ" color="success" />
      {paidInfo?.paid_by_group && (
        <Chip
          size="small"
          label={paidInfo.paid_by_name ? `Toplu ödeme · ${paidInfo.paid_by_name}` : "Toplu ödeme"}
          style={{ background: "#eeedfe", color: "#302b63", border: "1px solid #afa9ec", fontSize: 11 }}
        />
      )}
    </span>
  );

  // if (productIds.length === 0) {
  //   return (
  //     <div className="activeProductBox">
  //       <h2>Şu an aktif ürün bulunmamaktadır.</h2>
  //     </div>
  //   );
  // }

  const isAllCompulsaryFieldsFilled =
    user &&
    user.name &&
    user.birth_year &&
    user.gender &&
    user.city &&
    user.education &&
    user.occupation;

  const purchaseClicked = async () => {
    // alert("Kongre kayıtları sona ermiştir. İlginiz için teşekkür ederiz.");

    if (!user.name || !user.birth_year || !user.phone) {
      alert(
        "Ödeme adımına ilerlemeden önce lütfen ad-soyad, telefon ve doğum tarihi bilgilerinizi eksiksiz olarak doldurunuz."
      );
      return;
    }

    // TODO: burada stoklar halen var mı kontrol et..

    const price = calculateTotalPrice();
    setIsPurchaseTriggered(true);

    const receipt = {
      price,
      season_id: activeSeason?.id,
      is_paid: false,
      receipt_products: selectedProducts,
      email: user.email,
      name: user.name ?? "",
    };

    if (user.coupon) {
      receipt.coupon_discount_amount = Math.min(
        user.coupon.amount,
        mainProduct?.price || 0
      );
      receipt.coupon_id = user.coupon?.id;
    }
    const newReceiptId = await createReceipt(receipt);
    if (!newReceiptId) return null;

    const params = {
      name: user.name,
      email: user.email,
      firebase_receipt_id: newReceiptId,
      requester_url: window.location.origin,
      price,
    };

    if (price === 0) {
      // window.location.href =
      //   "http://localhost:3000/payment_result?zero_payment=true";
      navigate(
        "/payment_result?zero_payment=true?firebase_receipt_id=" + newReceiptId
      );
    } else {
      const redirectUrl = await getPaymentUrl(params);

      if (redirectUrl.url) {
        const url = redirectUrl.url;
        const arr = url.split("/");
        const token = arr[arr.length - 1];
        const receipt = {
          token,
        };
        await updateReceipt(newReceiptId, receipt);
        window.location.href = url;
      } else
        alert("Ödeme ekranı açılırkan bir sorun oluştu. (Hata Kodu: BT91Z4)");
    }
  };

  const onProductSelected = (pId) => {
    if (selectedProducts[pId]) {
      delete selectedProducts[pId];
    } else {
      selectedProducts[pId] = true;
    }
    setSelectedProducts({ ...selectedProducts });
  };

  const lockScreenForProfileData = (
    <div className="lock-screen">
      <div className="lock-screen-inner-box">
        <LockIcon style={{ fontSize: "xxx-large", marginBottom: 5 }} />
        <span> LÜTFEN EKSİK PROFİL BİLGİLERİNİZİ GÜNCELLEYİNİZ.</span>
      </div>
    </div>
  );

  const renderMainProduct = () => {
    if (!mainProduct) return null;

    const isMainProductPaid = !!paidProducts[mainProduct?.id];
    const isMainProductSelected = selectedProducts[mainProduct?.id];

    if (!isMainProductPaid && !isMainProductSelected) {
      selectedProducts[mainProduct?.id] = true;
      setSelectedProducts({ ...selectedProducts });
    }

    const handelPdfDownloadForGeneralInfo = () => {
      const pdfUrl = require("../../files/pdfs/general.pdf");
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "Genel Bilgiler.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    };

    const handlePdfDownloadForSpecificInfo = async () => {
      const receipts = user.activeSeasonReceipts; //await pullReceiptsByUser(user?.uid, activeSeason?.id);
      const pdfUrl = require("../../files/pdfs/KatilimciBilgileriTemplate.pdf");

      const customFontBytes = await loadTtfFont(
        "https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf"
      );

      const xhr = new XMLHttpRequest();
      xhr.open("GET", pdfUrl, true);
      xhr.responseType = "arraybuffer";

      xhr.onload = async function () {
        if (xhr.status === 200) {
          const arrayBuffer = xhr.response;
          const pdfDoc = await PDFDocument.load(arrayBuffer);
          pdfDoc.registerFontkit(fontkit);

          const customFont = await pdfDoc.embedFont(customFontBytes);
          const pages = pdfDoc.getPages();
          const firstPage = pages[0];
          const { width, height } = firstPage.getSize();
          firstPage.drawText(user?.name, {
            x: 150,
            y: height / 2 + 283,
            size: 10,
            font: customFont,
          });
          firstPage.drawText(user?.email, {
            x: 150,
            y: height / 2 + 265,
            size: 10,
            font: customFont,
          });

          let products = [];
          receipts.map((receipt) => {
            Object.keys(receipt.receipt_products).map((pId) => {
              if (pId !== mainProduct.id)
                products.push({
                  title: activeSeason?.products[pId]?.title,
                  room: activeSeason?.products[pId]?.room,
                  start_at: activeSeason?.products[pId]?.start_at,
                });
            });
          });

          if (products.length > 0) {
            firstPage.drawText("KAYIT YAPILAN ATÖLYELER/ÜRÜNLER", {
              x: 55,
              y: 175,
              size: 10,
              font: customFont,
            });
          }

          products
            .sort((p1, p2) => p1.start_at - p2.start_at)
            .forEach((p, index) => {
              const formattedStartAt = moment(p.start_at)
                .format("LLL")
                .toString();
              const productSummary =
                formattedStartAt + ": " + p?.title + " (" + p.room + ")";
              firstPage.drawText(productSummary, {
                x: 55,
                y: 160 - index * 16,
                size: 10,
                font: customFont,
              });
            });

          const pdfBytes = await pdfDoc.save();
          downloadModifiedPdf(pdfBytes, "KatilimBelgesi");
        } else {
          alert("Belge indirilirken bir sorun oldu.");
        }
      };
      xhr.send();
      return;
    };

    return (
      <div className="orderSummaryBox">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px",
            width: "100%",
          }}
        >
          {isMainProductPaid && paymentOkIndicator(paidProducts[mainProduct?.id])}
          {!isMainProductPaid && (
            <Checkbox
              color="secondary"
              onClick={() => {
                alert(
                  "Atölyelere katılabilmek için kongre katılım bedelinin ödenmesi gerekmektedir. Bu ürünü sepetinizden silemezsiniz."
                );
              }}
              checked={isMainProductSelected || isMainProductPaid}
            />
          )}
          <span
            style={{
              fontWeight: 700,
              color: "#222",
              marginRight: 6,
            }}
          >
            {mainProduct?.title}
          </span>

           {/* Erken kayıt fırsatı sona erdi, fiyat artık 950 TL sabit.
           <div
            className="mainProductBoxMobile"
            style={{
              position: "relative",
              background: "rgba(255,255,255,0.25)",
              borderRadius: 24,
              boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.18)",
              backdropFilter: "blur(8px)",
              border: "2px solid rgba(255,255,255,0.18)",
              padding: "28px 32px",
              display: "flex",
              alignItems: "center",
              gap: 24,
              marginBottom: 16,
              overflow: "hidden",
            }}
          >
            <span
              className="mobile-hide"
              style={{
                position: "absolute",
                left: 2,
                top: 6,
                fontSize: 22,
                opacity: 0.7,
              }}
            >
              🎉
            </span>
            <span
              className="mobile-hide"
              style={{
                position: "absolute",
                right: 2,
                bottom: 6,
                fontSize: 20,
                opacity: 0.6,
              }}
            >
              🎉
            </span>
            <span
              style={{
                textDecoration: "line-through",
                color: "red",
                fontWeight: 500,
                fontSize: 22,
                marginRight: 2,
              }}
            >
              950 TL
            </span>
            <span
              style={{
                fontWeight: 800,
                fontSize: 21,
                textDecoration: "underline",
                background: "rgb(48, 201, 48)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {mainProduct?.price} TL
            </span>
            <span
              style={{
                fontSize: 28,
                color: "#302b63",
                fontWeight: 700,
                animation: "arrowMove 1.2s infinite alternate",
              }}
            >
              🡺
            </span>
            <span
              style={{
                background: " rgba(48, 43, 99, 1)",
                color: "white",
                borderRadius: 28,
                padding: "4px 25px",
                fontWeight: 700,
                fontSize: 16,
                marginLeft: 12,
                boxShadow: "0 2px 12px #ff416c44",
                display: "flex",
                alignItems: "center",
                letterSpacing: 1,
              }}
            >
              <InfoOutlinedIcon
                style={{
                  fontSize: 21,
                  marginRight: 8,
                  filter: "drop-shadow(0 0 4px #fff)",
                }}
              />
              Erken Kayıt Fırsatı!
            </span>
            <span
              style={{
                fontSize: 28,
                color: "#302b63",
                fontWeight: 700,
                animation: "arrowMove 1.2s infinite alternate",
              }}
            >
              🡺
            </span>
            <span
              style={{
                background: "#EB5915",
                color: "#fff",
                borderRadius: 28,
                padding: "4px 16px",
                fontWeight: 900,
                marginLeft: 12,
                fontSize: 16,
                boxShadow: "0 0 8px 2px #EB5915",
                animation: "glow 1.5s infinite alternate",
              }}
            >
              %26 İndirim
            </span>
            <span
              style={{
                fontSize: 20,
                color: "#302b63",
                fontWeight: 700,
                animation: "arrowMove 1.2s infinite alternate",
              }}
            >
              🡺
            </span>
            <span
              style={{
                background: " rgba(48, 43, 99, 1)",
                color: "white",
                borderRadius: 28,
                padding: "4px 25px",
                fontWeight: 700,
                fontSize: 16,
                marginLeft: 12,
                boxShadow: "0 2px 12px #ff416c44",
              }}
            >
              ⏰ Son gün:{" "}
              <b style={{ marginLeft: 4, color: "#fff" }}>31 Ağustos 2026</b>
            </span>

            <style>
              {`
                @keyframes arrowMove {
                  0% { transform: translateX(0); }
                  100% { transform: translateX(12px) scale(1.1); }
                }
                @keyframes glow {
                  0% { box-shadow: 0 0 8px 2px #302b63, 0 0 0 #fff; }
                  100% { box-shadow: 0 0 18px 6px #302b63, 0 0 8px #fff; }
                }
              `}
            </style>
          </div>
          */}
          <span
            style={{
              fontWeight: 800,
              fontSize: 21,
              color: "#302b63",
            }}
          >
            {mainProduct?.price} TL
          </span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            marginTop: 8,
            justifyContent: "start",
            alignItems: "start",
          }}
        >
          {isMainProductPaid && (
            <div>
              <p>
                Aşağıdaki belgede, satın aldığınız kongre ve atölyelere ait
                bilgilere ulaşabilirsiniz.{" "}
              </p>
              <Button
                variant="contained"
                color="success"
                sx={{ mr: 2 }}
                onClick={handlePdfDownloadForSpecificInfo}
              >
                Kongre Katılım Bİlgİlerİ
              </Button>
                {/*<Button
                onClick={handelPdfDownloadForGeneralInfo}
                variant="contained"
              >
                Genel Bİlgİler
              </Button>  */}
            </div>
          )}
        </div>

      </div>

      
    );
  };

  const renderWorkshopDays = () => {
    return Object.keys(workshopDays)
      .sort((dayString1, dayString2) => dayString1.localeCompare(dayString2))
      .map((day) => {
        const workshops = workshopDays[day];
        return (
          <TableContainer
            key={day}
            style={{ marginBottom: 20, marginTop: 15 }}
            component={Paper}
          >
            <div className="workshopDayTableHeader">{day + ""}</div>

            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  {[
                    { columnTitle: "SEÇ", align: "center" },
                    { columnTitle: "Saat", align: "center" },
                    { columnTitle: "Atölye/Ürün Adı" },
                    { columnTitle: "Moderatör" },
                    { columnTitle: "Salon" },
                    { columnTitle: "Ücret" },
                    { columnTitle: "Stok", isForAdmin: true },
                  ].map((column) => {
                    if (column.isForAdmin && user.role !== "admin") return null;

                    return (
                      <TableCell
                        key={column.columnTitle}
                        style={{ fontWeight: "bold" }}
                        align={column.align}
                      >
                        {column.columnTitle}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {workshops.map((w) => {
                  const isStockAvailable = w?.stock > 0 && w?.is_closed !== true;
                  const isUserPurchasedThisProduct = paidProducts[w?.id];

                  if (!isStockAvailable && !isUserPurchasedThisProduct)
                    return null;

                  return (
                    <TableRow
                      key={w?.id}
                      title={
                        w?.isOverlapping
                          ? "Seçtiğiniz başka bir atölyenin saatleri ile çakıştığı için bu atölyeyi seçemezsiniz."
                          : ""
                      }
                    >
                       <TableCell
                        align="center"
                        onClick={() => {
                          if (w?.isOverlapping) {
                            alert(
                              "Seçtiğiniz başka bir atölyenin saatleri ile çakıştığı için bu atölyeyi seçemezsiniz."
                            );
                          } else if (!isUserPurchasedThisProduct) {
                            onProductSelected(w.id);
                          }
                        }}
                        style={{
                          cursor:
                            w?.isOverlapping || isUserPurchasedThisProduct
                              ? "default"
                              : "pointer",
                        }}
                      >
                        {!isUserPurchasedThisProduct && (
                          <Checkbox
                            color="secondary"
                            checked={!!selectedProducts[w.id]}
                            disabled={w.isOverlapping}
                          />
                        )}
                        {isUserPurchasedThisProduct && paymentOkIndicator(paidProducts[w?.id])}
                      </TableCell> 

                      <TableCell component="th" scope="row" align="center">
                        {moment(w?.start_at).format("HH:mm").toString() +
                          " - " +
                          moment(w?.end_at).format("HH:mm").toString()}
                      </TableCell>
                      <TableCell>{w?.title}</TableCell>
                      {/* <TableCell>{w.description}</TableCell> */}
                      <TableCell>{w?.moderator}</TableCell>
                      <TableCell>{w?.room}</TableCell>
                      <TableCell>{w?.price + " TL"}</TableCell>
                      {user.role === "admin" && (
                        <TableCell>{w?.stock}</TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        );
      });
  };
  const calculateTotalPrice = () => {
    let totalPrice = Object.keys(selectedProducts).reduce((acc, pId) => {
      const productPrice = activeSeasonProductsObject[pId]?.price || 0;
      return productPrice + acc;
    }, 0);

    if (user.coupon) {
      const discount = Math.min(user.coupon.amount, mainProduct?.price || 0);
      totalPrice -= discount;
    }
    if (totalPrice < 0) totalPrice = 0;

    return totalPrice;
  };

  const rendereOrderSummary = () => {
    if (Object.keys(selectedProducts).length == 0) return null;
    const selectedProductCount = Object.keys(selectedProducts).filter(
      (pId) => selectedProducts[pId] > 0
    ).length;
    //  console.log("selectedProductCount", selectedProductCount);

    return (
      <div
        className="orderSummaryBox"
        style={{
          background: "rgba(255,255,255,0.25)",
          borderRadius: 24,
          boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.18)",
          backdropFilter: "blur(8px)",
          border: "2px solid rgba(255,255,255,0.18)",
          padding: "8px 22px 24px 32px",
          marginTop: 12,
          marginBottom: 8,
          maxWidth: 700,
          marginLeft: "auto",
          marginRight: "auto",
          position: "relative",
        }}
      >
        <h4 className="basket">
          Sepetinizdeki Kongre Katılım ve Atölye Ürünleri
        </h4>
        {Object.keys(selectedProducts).map((pId) => {
          const p = activeSeasonProductsObject[pId];
          const isMainProductRow = mainProduct && pId === mainProduct.id;
          const couponDiscount =
            isMainProductRow && user.coupon
              ? Math.min(user.coupon.amount, p?.price || 0)
              : 0;

          return (
            <div
              key={pId + "_for_summary"}
              className="productRow"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: 18,
                fontWeight: 700,
                textAlign: "left",
                marginBottom: 8,
              }}
            >
              <div className="productTitle">{p?.title}</div>
              <div
                className="productPrice"
                style={{
                  fontWeight: 900,
                  fontSize: 18,
                  color: "rgb(48, 201, 48)",
                }}
              >
                {couponDiscount > 0 && (
                  <span
                    style={{
                      textDecoration: "line-through",
                      color: "red",
                      fontWeight: 500,
                      marginRight: 6,
                    }}
                  >
                    {p?.price} TL
                  </span>
                )}
                {(p?.price || 0) - couponDiscount} TL
              </div>
            </div>
          );
        })}

        <p
          className="totalPrice"
          style={{
            fontSize: 17,
            fontWeight: 900,
            color: "#302b63",
            textAlign: "center",
            margin: "18px 0 12px 0",
            letterSpacing: 1,
          }}
        >
          {"Seçilen " +
            selectedProductCount +
            " ürün için toplam tutar: " +
            calculateTotalPrice() +
            " TL"}
        </p>

        {user.coupon ? (
          <p
            className="couponApplied"
            style={{ color: "red", fontWeight: 700, textAlign: "center" }}
          >
            {"İndirim kuponu uygulanmıştır."}
          </p>
        ) : (
          <p style={{ textAlign: "center", margin: "0 0 8px 0" }}>
            <Link
              to="/sss#odtu-indirim"
              style={{ color: "#302b63", fontWeight: 700, textDecoration: "underline" }}
            >
              ODTÜ öğrencisi iseniz indirim için tıklayınız
            </Link>
          </p>
        )}

        <Alert severity="info" sx={{ mt: 2, mb: 1, textAlign: "left", fontSize: "0.82rem" }}>
          Kurumsal ödeme taleplerinde, kurumun bilgisi ve onayı dahilinde talepte bulunulması gerekmektedir.
        </Alert>

        <Alert severity="info" sx={{ mb: 1, textAlign: "left", fontSize: "0.82rem" }}>
          Kendinizle birlikte başka kişiler için de ödeme yapmak istiyorsanız, {" "}
          <Link
            to="/bulk-payment"
            style={{ color: "#302b63", fontWeight: 700, textDecoration: "underline" }}
          >
            Toplu Ödeme
          </Link>{" "}
          sayfasını kullanabilirsiniz.
        </Alert>

        <Button
          sx={{
            background: "#302B63",

            color: "#fff",
            fontWeight: 700,
            fontSize: 15,
            borderRadius: 16,
            boxShadow: "0 2px 5px #ff416c44",
            marginTop: 2,
            letterSpacing: 1,
            transition: "0.2s",
            "&:hover": {
              background:
                " linear-gradient(85deg,rgba(48, 43, 99, 0.99) 18%, rgba(48, 43, 99, 1) 64%, rgba(230, 48, 130, 0.85) 100%)",
              boxShadow: "0 1px 3px #E63082",
            },
          }}
          className="proceedButton"
          variant="contained"
          onClick={purchaseClicked}
          fullWidth
        >
          ÖDEME ADIMINA İLERLE
        </Button>
      </div>
    );
  };

  if (isMainProductStocksZero && !isMainProductPaid)
    return (
      <div className="personelInfoBox">
        <h3 className="pageHeader">KONGRE VE ATÖLYELER</h3>
        <p>
          Kongre ve atölye başvuruları için sistem yakında aktif hale
          gelecektir. Detaylı bilgi için info@tzv.org.tr adresine e-posta
          gönderebilirsiniz.
        </p>
      </div>
    );

  return (
    <>
      <div className="personelInfoBox">
      <h3 className="pageHeader">KONGRE VE ATÖLYELER</h3>

      <div className="eventInfoCard">
        <div className="eventInfoItem">
          <div className="eventInfoIcon">
            <EventIcon />
          </div>
          <div className="eventInfoText">
            <span className="eventInfoDate">7 Kasım 2026 · Ana Oturum</span>
            <span className="eventInfoLocation">
              <LocationOnIcon style={{ fontSize: 15, marginRight: 3, verticalAlign: "text-bottom" }} />
              ODTÜ KKM, Ankara
            </span>
          </div>
        </div>
        <div className="eventInfoItem workshop">
          <div className="eventInfoIcon">
            <EventIcon />
          </div>
          <div className="eventInfoText">
            <span className="eventInfoDate">8 Kasım 2026 · Atölyeler</span>
            <span className="eventInfoLocation">
              <LocationOnIcon style={{ fontSize: 15, marginRight: 3, verticalAlign: "text-bottom" }} />
              ODTÜ Eğitim Fakültesi, Ankara
            </span>
          </div>
        </div>
      </div>

           {renderMainProduct()}
         {renderWorkshopDays()} 
      {rendereOrderSummary()} 
     </div> 
    </>
  );
};
